import { Amplify } from 'aws-amplify';

import AmplifyVue from '@aws-amplify/ui-vue';
import apiConfig from '@/configs/api';

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: apiConfig.amplify.region,
    userPoolId: apiConfig.amplify.userPoolId,
    userPoolWebClientId: apiConfig.amplify.userPoolWebClientId,
    identityPoolId: apiConfig.amplify.identityPoolId,
    oauth: {
      domain: apiConfig.amplify.domain,
      scope: [
        'email',
        'openid',
        'profile',
      ],
      redirectSignIn: apiConfig.amplify.redirectUri,
      response_type: 'code',
    },
  },
});

export default AmplifyVue;
